import webLogin from '@utils/weblogin';
import util from '@utils/util';
var index = {
  doConvert: function doConvert() {
    util.KEWLSensorTrack({
      lmweb_clickText: '跳转',
      lmweb_tabName: 'doConvert'
    });
    var userInfo = webLogin.getUserInfoData();
    var href = '';
    if (window.bridge && window.bridge.webConvertAndCash) {
      href = window.bridge.webConvertAndCash.doConvert(userInfo);
      if (href) {
        window.location.href = href;
        return;
      }
    }

    //TODO: - 工程都改版完，以下代码可以删除
    if (webLogin.checkLogin()) {
      window.location.href = location.protocol + '//' + location.host + '/app/withdraw/?thirdchannel=6&h5=1#/';
    } else {
      window.location.href = '/app/neww/dist/index.html';
    }
  },
  doCashOut: function doCashOut() {
    util.KEWLSensorTrack({
      lmweb_clickText: '跳转',
      lmweb_tabName: 'doCashOut'
    });
    var userInfo = webLogin.getUserInfoData();
    var href = '';
    if (window.bridge && window.bridge.webConvertAndCash) {
      href = window.bridge.webConvertAndCash.doCashOut(userInfo);
      if (href) {
        window.location.href = href;
        return;
      }
    }

    //TODO: - 工程都改版完，以下代码可以删除
    if (webLogin.checkLogin()) {
      window.location.href = location.protocol + '//' + location.host + '/app/withdraw/?thirdchannel=6&h5=1#/';
    } else {
      window.location.href = '/app/neww/dist/index.html';
    }
  }
};
export default index;